(function () {
  const mqNarrow = window.matchMedia('(max-width: 1023px)');

  function bindShell(root) {
    const wrap = root.querySelector('[data-technical-data-custom-table]');
    const rail = root.querySelector('[data-technical-data-custom-rail]');
    const thumb = root.querySelector('[data-technical-data-custom-thumb]');
    const track = rail && rail.querySelector('.technical-data-custom__scroll-rail-track');
    if (!wrap || !rail || !thumb || !track) return;

    function update() {
      const narrow = mqNarrow.matches;
      const max = wrap.scrollWidth - wrap.clientWidth;
      const hasOverflow = narrow && max > 2;

      root.classList.toggle('technical-data-custom__scroll-shell--overflow', hasOverflow);
      const atEnd = !hasOverflow || wrap.scrollLeft >= max - 2;
      root.classList.toggle('technical-data-custom__scroll-shell--hint', hasOverflow && !atEnd);

      if (!hasOverflow) {
        thumb.style.width = '';
        thumb.style.transform = '';
        return;
      }

      const trackW = track.clientWidth;
      if (trackW < 8) return;

      const ratio = wrap.clientWidth / wrap.scrollWidth;
      const thumbW = Math.max(28, Math.round(trackW * ratio));
      const maxThumbLeft = Math.max(0, trackW - thumbW);
      const thumbLeft = max > 0 ? (wrap.scrollLeft / max) * maxThumbLeft : 0;
      thumb.style.width = `${thumbW}px`;
      thumb.style.transform = `translate3d(${thumbLeft}px, 0, 0)`;
    }

    function scheduleUpdate() {
      update();
      requestAnimationFrame(update);
    }

    wrap.addEventListener('scroll', update, { passive: true });
    if (typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(() => scheduleUpdate());
      ro.observe(wrap);
      ro.observe(root);
    }
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    if (typeof mqNarrow.addEventListener === 'function') {
      mqNarrow.addEventListener('change', scheduleUpdate);
    } else if (typeof mqNarrow.addListener === 'function') {
      mqNarrow.addListener(scheduleUpdate);
    }
    scheduleUpdate();
  }

  document.querySelectorAll('[data-technical-data-custom]').forEach(bindShell);
})();
